import { isApiBusinessErrorCode } from './business-error-code.js';
import { isApiRequestInvalidCode, parseRequestInvalidIssues, } from './request-invalid.js';
/**
 * 응답 `code`가 계약 또는 비즈니스 코드인지 본다.
 * 사람 문장·Nest 기본 message는 코드로 쓰지 않는다.
 */
export function isApiErrorCode(value) {
    return isApiRequestInvalidCode(value) || isApiBusinessErrorCode(value);
}
/** Nest 기본 키와 레거시 사람 문구. 계약 사실로 읽지 않는다. */
const NON_FACT_KEYS = new Set(['statusCode', 'message', 'error']);
/**
 * HTTP status만으로 프론트가 쓰는 일반 문구를 고른다.
 * 비즈니스 코드 사전은 여기 두지 않는다. 화면이 갈라질 때 호출부가 로컬에서 고른다.
 */
export function genericMessageFromHttpStatus(status) {
    if (status === 400) {
        return '요청을 처리할 수 없습니다.';
    }
    if (status === 401) {
        return '로그인이 필요합니다.';
    }
    if (status === 403) {
        return '권한이 없습니다.';
    }
    if (status === 404) {
        return '찾을 수 없습니다.';
    }
    if (status === 409) {
        return '요청이 현재 상태와 충돌합니다.';
    }
    if (status === 429) {
        return '잠시 후 다시 시도해 주세요.';
    }
    if (status >= 500) {
        return '서버 오류가 발생했습니다.';
    }
    return '요청에 실패했습니다.';
}
/**
 * 네트워크·레거시 응답을 계약 body로 좁힌다.
 * 빈 본문과 Nest 기본 형태는 `code` 없는 빈 객체로 본다.
 */
export function parseApiErrorBody(body) {
    if (!body || typeof body !== 'object' || Array.isArray(body)) {
        return {};
    }
    const record = body;
    const parsed = {};
    const code = record.code;
    // 형식이 맞는 코드만 살린다. 사람 문장·임의 문자열이 사전 키로 쓰이지 않게 한다.
    if (isApiErrorCode(code)) {
        parsed.code = code;
    }
    const issues = parseRequestInvalidIssues(record.issues);
    if (issues) {
        parsed.issues = issues;
    }
    for (const [key, value] of Object.entries(record)) {
        if (key === 'code' || key === 'issues' || NON_FACT_KEYS.has(key)) {
            continue;
        }
        parsed[key] = value;
    }
    return parsed;
}
/**
 * 백엔드 HTTP 실패. `code`가 있으면 호출부가 로컬 사전으로 처리하고,
 * 없으면 `message`의 HTTP 일반 문구를 쓴다.
 */
export class ApiError extends Error {
    /** 계약 또는 비즈니스 코드. 없으면 HTTP status 일반 처리다. */
    code;
    /** 요청 Zod 실패일 때 필드 힌트. 폼이 path+code로 같은 UI에 붙인다. */
    issues;
    /** 파싱된 사실 필드. 사람 문구는 들어오지 않는다. */
    data;
    /** HTTP status. body가 비면 이 값으로 일반 문구를 고른다. */
    status;
    constructor(status, body = {}) {
        const data = parseApiErrorBody(body);
        super(genericMessageFromHttpStatus(status));
        this.name = 'ApiError';
        this.status = status;
        this.code = data.code;
        this.issues = data.issues;
        this.data = data;
    }
}
//# sourceMappingURL=api-error.js.map